import { modal } from '@/components/modal/Modal';
import axios, { InternalAxiosRequestConfig } from 'axios';

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	timeout: 1000 * 60 * 5, // 5 minutes (could be less)
});

instance.interceptors.request.use((config) => {
	modal.blockScreen(true);
	const token = localStorage.getItem('token');
	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}
	return config;
});

const refreshAccessToken = async () => {
	const refreshToken = localStorage.getItem('refresh_token');
	const response = await axios.post(
		`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`,
		{
			grant_type: 'refresh_token',
			client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
			refresh_token: refreshToken,
			client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
		},
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		}
	);
	const { access_token, refresh_token } = response.data;
	localStorage.setItem('token', access_token);
	localStorage.setItem('refresh_token', refresh_token);
};

instance.interceptors.response.use(
	(response) => {
		modal.blockScreen(false);
		return response;
	},
	async (error) => {
		const originalRequest = error.config as InternalAxiosRequestConfig<any>;
		const message = error.response?.data?.detail as string;
		if (message?.includes('Signature has expired')) {
			await refreshAccessToken();
			return instance(originalRequest);
		}
		if (error.message.includes('timeout')) {
			modal.error({
				title: 'Error',
				message: 'Request timeout, try later!',
			});
		}
		modal.blockScreen(false);
		if (typeof error.response?.data === 'string') {
			modal.error({
				title: 'Error',
				message: error.response.data || 'Something went wrong',
			});
		}
		return Promise.reject(error);
	}
);

export default instance;
